import WelcomeOnBoard from 'components/onboarding/WelcomeOnBoard';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { EcoBackendEcoregion } from 'services/bioregion';
import { User, UserLearningPath } from 'services/graphqltypes';
import ActivateDiscourseChat from './ActivateDiscourseChat';
import { UserContext } from 'contexts/user/UserContext';

export type OnboardingProps = {
  userInfo?: {
    currentUser?: User,
  }
  modalState?: {
    showModal?: boolean,
    setShowModal?: React.Dispatch<React.SetStateAction<boolean>>,
  }
  bioregionInfo?: {
    currentBioregion: EcoBackendEcoregion,
    setCurrentBioregion: React.Dispatch<React.SetStateAction<EcoBackendEcoregion>>,
  }
  userLearningPaths?: UserLearningPath[],
  setStepId?: React.Dispatch<React.SetStateAction<number>>,
  userObject?: User,
}

/** A modal that shows on first log-in and helps the user complete their ARK setup. */
const Onboarding = ({ userInfo }: OnboardingProps) => {
  const [showModal, setShowModal] = useState(true);
  const [step, setStep] = useState<'profile' | 'chat'>('profile');
  const { refetchCurrentUser } = React.useContext(UserContext);

  const finishOnboarding = () => {
    refetchCurrentUser()
      .catch((error) => console.warn('Failed to refresh the current user after onboarding.', error))
      .finally(() => setShowModal(false));
  };

  return (
    <Modal
      show={showModal}
      backdrop="static" /* prevent closing modal when clicked outside it*/
      keyboard={false} /* prevent closing the modal using Keyboard events */
      size="lg"
      backdropTransition={{ timeout: 400 }}
      className='rounded-modal'>
      <Modal.Body className="px-3">
        {step === 'profile'
          ? <WelcomeOnBoard userInfo={userInfo} onComplete={() => setStep('chat')} />
          : <ActivateDiscourseChat onLater={finishOnboarding} />}
      </Modal.Body>
    </Modal>
  );
};

export default Onboarding;
